import React from 'react';
import { LoadingIcon } from 'basis';
import styled from '@emotion/styled';

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 35%;
  background-color: #20df5c;
  font-family: 'Latitude Sans', sans-serif;
  &:hover:not(:disabled) {
    background-color: var(--Background-Primary-hover, #6cf898);
  }
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  border: none;
  border-radius: 4px;
  cursor: ${props => (props.disabled || props.loading ? 'not-allowed' : 'pointer')};
  transition: all 0.3s;

  ${props => `
    ${`@media (max-width: ${props.theme.screenSize.md})`} {
      width: 100%;
    }
  `}
`;

export const StartApplicationButton = ({ loading, disabled, theme, children }) => {
  return (
    <StyledButton
      disabled={disabled}
      type="submit"
      loading={loading}
      theme={theme}
      data-testid="start-application-button"
    >
      {loading ? (
        <LoadingIcon />
      ) : (
        <b style={{ color: 'var(--Flat-colours-Indigo, var(--Indigo-1000, #0b2374))', fontSize: 16 }}>{children}</b>
      )}
    </StyledButton>
  );
};
